import React, { useState } from "react";
import "./QROverlay.css";
import qrCodeImage from "../assets/qr-code.png"; // Replace with your actual QR code image
import wsjXideo from "../assets/wsj x ideo.svg"; // Replace with your actual QR code image
import { DeviceMobileSpeaker } from "@phosphor-icons/react";

import { borderRadius, spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import Typography from "./Typography";

import Instructions from "../assets/svgs/Instructions.svg";

const QROverlay = ({ setShowHotspots, showHotspots }) => {
    const { theme } = useTheme();
    const [isOpen, setIsOpen] = useState(false);

    // Toggle overlay
    const toggleOverlay = () => {
        setIsOpen(!isOpen);
    };

      const styles = {
        buttonContainer: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: `${spacing.l}px ${spacing.m}px ${spacing.xxxs}px ${spacing.m}px`,
        },
        button: {
          padding: `${spacing.s}px ${spacing.m}px`,
          background: theme.colors.fillSecondary,
          color: theme.colors.contentPrimary,
          border: `1px solid rgba(255, 255, 255, 0.4)`,
          borderRadius: borderRadius.xl,
          cursor: "pointer",
          transition: "background 0.3s ease-in-out",
        }
      }

    return (
        <>
            {/* Top Left Button */}
            <div className="top-left-container">
                <h1>Markets, Refreshed</h1>
                <p>A concept design by the Wall Street Journal  and IDEO</p>
                <button className="qr-button" onClick={toggleOverlay}>
                    <DeviceMobileSpeaker/>
                     Try The Experience on Mobile
                </button>
                <button
                    className="toggle-hotspots-btn qr-button"
                    onClick={() => setShowHotspots(!showHotspots)}
                >
                {showHotspots ? "Hide Hotspots" : "Show Hotspots"}
                </button>
            </div>

            <div className="bottom-container footer">
              <p className="disclaimer">Confidential • For Demo Purposes Only • Updated March 2025</p>
              <img src={wsjXideo} className="logo"></img>
            </div>

            {/* QR Code Overlay */}
            {isOpen && (
                <div className="qr-overlay">
                    <div className="qr-content">
                        <Typography variant="headlineMedia" type="editorial" style={{fontSize: 18}}>Scan to Try on Mobile</Typography>
                        <img src={qrCodeImage} alt="QR Code" className="qr-image" />
                        <Typography variant="summary" type="editorial">Open your camera and scan the QR code to experience this prototype on your phone.</Typography>
                        <div className="qr-tips">
                            <img src={Instructions} alt="Instructions" />
                        </div>

                        <div style={styles.buttonContainer} >
                            <button style={styles.button} onClick={toggleOverlay}>
                                <Typography variant="summary" type="editorial">✖ Close</Typography>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default QROverlay;
